import { axios } from '@/utils/request'

const api = {
  goodsOptions: '/badminapi/goods/goodsOptions',
  cateTreeList: '/badminapi/goods/businessCateList',
  cateList: '/badminapi/goods/businessCateList',
  cateAdd: '/badminapi/goods/businessCateAdd',
  cateEdit: '/badminapi/goods/businessCateEdit',
  cateDelete: '/badminapi/goods/businessCateDelete',
  cateDetail: '/badminapi/goods/businessCateDetail',
  setCateRank: '/badminapi/goods/setCateRank',
  fieldList: '/badminapi/goods/fieldList',
  attrList: '/badminapi/goods/attrList',
  skuFieldAdd: '/badminapi/goods/skuFieldAdd',
  skuAttrAdd: '/badminapi/goods/skuAttrAdd',
  skuAttrDelete: '/badminapi/goods/skuAttrDelete',
  skuFieldDelete: '/badminapi/goods/skuFieldDelete',
  skuDetail: '/badminapi/goods/skuDetail',
  stockSetInc: '/badminapi/goods/stockSetInc',
  skuEdit: '/badminapi/goods/skuEdit',
  goodsEdit: '/badminapi/goods/goodsEdit',
  goodsAdd: '/badminapi/goods/goodsAdd',
  goodsContentEdit: '/badminapi/goods/goodsContentEdit',
  goodsDetail: '/badminapi/business/businessGoodsDetail',
  goodsList: '/badminapi/business/businessGoodsList',
  setGoodsStatus: '/badminapi/goods/setGoodsStatus',
  setGoodsAllStatus: '/badminapi/goods/setGoodsAllStatus',
  goodsDelete: '/badminapi/goods/goodsDelete',
  goodsRankEdit: '/badminapi/goods/goodsRankEdit',
  getSellerRewardSetting: '/badminapi/goods/getSellerRewardSetting',
  sellerRewardSetting: '/badminapi/goods/sellerRewardSetting',
  getDealtownRewardSetting: '/badminapi/goods/getDealtownRewardSetting',
  dealtownRewardSetting: '/badminapi/goods/dealtownRewardSetting',
  getBaseOptions: '/badminapi/businessbase/baseOptions',
  onHandleRecom: '/badminapi/goods/onHandleRecom',
  NotHandleRecom: '/badminapi/goods/NotHandleRecom', 
}

export default api

export function getGoodsList(parameter) {
  return axios({
    url: api.goodsList,
    method: 'get',
    params: parameter
  })
}
export function getGoodsOptions(parameter) {
  return axios({
    url: api.goodsOptions,
    method: 'get',
    params: parameter
  })
}
export function getBusinessGoodsDetail(parameter) {
  return axios({
    url: api.goodsDetail,
    method: 'get',
    params: parameter
  })
}
export function getCateTreeList(parameter) {
  return axios({
    url: api.cateTreeList,
    method: 'get',
    params: parameter
  })
}
export function getCateList(parameter) {
  return axios({
    url: api.cateList,
    method: 'get',
    params: parameter
  })
}
export function addGoods(parameter) {
  return axios({
    url: api.goodsAdd,
    method: 'post',
    data: parameter
  })
}
export function editGoods(parameter) {
  return axios({
    url: api.goodsEdit,
    method: 'post',
    data: parameter
  })
}
export function addCate(parameter) {
  return axios({
    url: api.cateAdd,
    method: 'post',
    data: parameter
  })
}
export function setCateRank(parameter) {
  return axios({
    url: api.setCateRank,
    method: 'post',
    data: parameter
  })
}
export function editCate(parameter) {
  return axios({
    url: api.cateEdit,
    method: 'post',
    data: parameter
  })
}
export function deleteCate(parameter) {
  return axios({
    url: api.cateDelete,
    method: 'post',
    data: parameter
  })
}
export function getCateDetail(parameter) {
  return axios({
    url: api.cateDetail,
    method: 'get',
    params: parameter
  })
}
export function getAttrList(parameter) {
  return axios({
    url: api.attrList,
    method: 'get',
    params: parameter
  })
}
export function getFieldList(parameter) {
  return axios({
    url: api.fieldList,
    method: 'get',
    params: parameter
  })
}
export function skuFieldAdd(parameter) {
  return axios({
    url: api.skuFieldAdd,
    method: 'post',
    data: parameter
  })
}
export function skuAttrAdd(parameter) {
  return axios({
    url: api.skuAttrAdd,
    method: 'post',
    data: parameter
  })
}
export function skuAttrDelete(parameter) {
  return axios({
    url: api.skuAttrDelete,
    method: 'post',
    data: parameter
  })
}
export function skuFieldDelete(parameter) {
  return axios({
    url: api.skuFieldDelete,
    method: 'post',
    data: parameter
  })
}


export function skuDetail(parameter) {
  return axios({
    url: api.skuDetail,
    method: 'get',
    params: parameter
  })
}
export function stockSetInc(parameter) {
  return axios({
    url: api.stockSetInc,
    method: 'post',
    data: parameter
  })
}
export function skuEdit(parameter) {
  return axios({
    url: api.skuEdit,
    method: 'post',
    data: parameter
  })
}
export function goodsContentEdit(parameter) {
  return axios({
    url: api.goodsContentEdit,
    method: 'post',
    data: parameter
  })
}
export function setGoodsAllStatus(parameter) {
  return axios({
    url: api.setGoodsAllStatus,
    method: 'post',
    data: parameter
  })
}
export function setGoodsStatus(parameter) {
  return axios({
    url: api.setGoodsStatus,
    method: 'post',
    data: parameter
  })
}
export function deleteGoods(parameter) {
  return axios({
    url: api.goodsDelete,
    method: 'post',
    data: parameter
  })
}
export function setGoodsRank(parameter) {
  return axios({
    url: api.goodsRankEdit,
    method: 'post',
    data: parameter
  })
}


export function sellerRewardSetting(parameter) {
  return axios({
    url: api.sellerRewardSetting,
    method: 'post',
    data: parameter
  })
}

export function getSellerRewardSetting(parameter) {
  return axios({
    url: api.getSellerRewardSetting,
    method: 'get',
    params: parameter
  })
}



export function dealtownRewardSetting(parameter) {
  return axios({
    url: api.dealtownRewardSetting,
    method: 'post',
    data: parameter
  })
}

export function getDealtownRewardSetting(parameter) {
  return axios({
    url: api.getDealtownRewardSetting,
    method: 'get',
    params: parameter
  })
}
export function getBaseOptions(parameter) {
  return axios({
    url: api.getBaseOptions,
    method: 'get',
    params: parameter
  })
}
export function onHandleRecom(parameter) {
  return axios({
    url: api.onHandleRecom,
    method: 'post',
    params: parameter
  })
}
export function NotHandleRecom(parameter) {
  return axios({
    url: api.NotHandleRecom,
    method: 'post',
    params: parameter
  })
}


